import { useNavigate } from 'react-router-dom';
import { Home } from 'lucide-react';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center px-4">
      <div className="text-center">
        <h1 className="text-9xl font-bold text-primary-900">404</h1>
        <p className="text-2xl font-semibold text-gray-700 mt-4">Page Not Found</p>
        <p className="text-gray-500 mt-2 mb-8">
          The page you're looking for doesn't exist or you don't have permission to access it.
        </p>
        <button onClick={() => navigate('/dashboard')} className="btn-primary inline-flex items-center space-x-2">
          <Home className="w-5 h-5" />
          <span>Go to Dashboard</span>
        </button>
      </div>
    </div>
  );
};

export default NotFound;

